module.exports = __webpack_public_path__ + "img/logo.fc4e836b.png";